/**
 * Heil Ginseng Theme JavaScript
 */

(function() {
  'use strict';

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      e.preventDefault();
      const target = document.querySelector(href);
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Lazy load images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }

  // Simple mobile menu toggle (if needed later)
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }

  // Judge.me review form ownership stays inside templates/product.liquid.

  function removeEmptySubscriptionControls() {
    const deliverySelect = document.getElementById('heil-pdp__delivery-select');
    const subscribeButton = document.querySelector('.heil-pdp__toggle-btn[data-mode="subscribe"]');
    const hasDeliveryOptions = deliverySelect &&
      !deliverySelect.disabled &&
      deliverySelect.options &&
      deliverySelect.options.length > 0;

    if (hasDeliveryOptions || (!deliverySelect && !subscribeButton)) return;

    const sellingPlanInput = document.getElementById('heil-pdp__selling-plan-input');
    const deliveryWrapper = deliverySelect && deliverySelect.closest('.heil-pdp__delivery');
    const subBenefits = document.querySelector('.heil-pdp__sub-benefits');
    const oneTimeButton = document.querySelector('.heil-pdp__toggle-btn[data-mode="once"]');

    if (sellingPlanInput) {
      sellingPlanInput.value = '';
      sellingPlanInput.remove();
    }
    if (subscribeButton) subscribeButton.remove();
    if (deliveryWrapper) deliveryWrapper.remove();
    else if (deliverySelect) deliverySelect.remove();
    if (subBenefits) subBenefits.remove();
    if (oneTimeButton) oneTimeButton.classList.add('active');
  }

  removeEmptySubscriptionControls();
  document.addEventListener('DOMContentLoaded', removeEmptySubscriptionControls);

  function ensureProp65Warning() {
    const prop65ProductPaths = [
      '/products/american-ginseng-capsules-500mg',
      '/products/ginseng-powder'
    ];
    if (!prop65ProductPaths.includes(window.location.pathname)) return;
    if (document.querySelector('.hg-prop65-warning')) return;

    const cartRow = document.querySelector('.heil-pdp__cart-row');
    if (!cartRow || !cartRow.parentNode) return;

    const warning = document.createElement('div');
    warning.className = 'hg-prop65-warning';
    warning.setAttribute('role', 'note');
    warning.innerHTML = [
      '<strong>California Prop 65 Warning</strong>',
      '<span>',
      'Consuming this product can expose you to lead, which is known to the State of California ',
      'to cause cancer and birth defects or other reproductive harm. See ',
      '<a href="https://www.P65Warnings.ca.gov/food" rel="noopener" target="_blank">www.P65Warnings.ca.gov/food</a>.',
      '</span>'
    ].join('');

    cartRow.parentNode.insertBefore(warning, cartRow);
  }

  ensureProp65Warning();
  document.addEventListener('DOMContentLoaded', ensureProp65Warning);

  // Add to cart (basic - will enhance later)
  document.querySelectorAll('[data-add-to-cart]').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      const productId = this.dataset.productId;
      const quantity = this.dataset.quantity || 1;
      const reloadOnAdd = this.dataset.reloadOnAdd === 'true';
      const originalLabel = this.textContent;

      if (reloadOnAdd) {
        this.disabled = true;
        this.textContent = 'Adding…';
      }

      // Simple add to cart (Shopify AJAX API)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        if (reloadOnAdd) {
          window.location.reload();
          return;
        }
        console.log('Added to cart:', data);
        // Update cart count (basic - will enhance later)
        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              cartLink.textContent = `Cart (${cart.item_count})`;
            });
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        if (reloadOnAdd) {
          this.disabled = false;
          this.textContent = originalLabel;
        }
      });
    });
  });

  console.log('Heil Ginseng theme initialized');
})();
